import styled from "styled-components";
import {
	DESKTOP_L_BP,
	TABLET_M_BP,
	TABLET_BP,
	MOBILE_L_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const ComponentWrapper = styled.div`
	position: relative;
	overflow: hidden;

	.text-wrapper-page-not-found {
		margin: 235px auto 130px auto;
		max-width: 500px;

		display: flex;
		flex-direction: column;
		align-items: center;
		row-gap: 24px;

		.heading {
			color: ${(p) =>
				p.headingColor ? p.headingColor : "var(--primary-green-400)"};
			text-align: center;
		}
		.description {
			color: ${(p) =>
				p.descriptionColor
					? p.descriptionColor
					: "var(--primary-neutral-white)"};
			text-align: center;
		}
		@media only screen and (max-width: ${TABLET_M_BP}px) {
			padding-inline: 24px;
			margin: 180px auto;
		}
	}

	.line-left {
		top: 40%;
		@media only screen and (max-width: ${DESKTOP_L_BP}px) {
			top: 30%;
		}
		@media only screen and (max-width: ${TABLET_M_BP}px) {
			top: 25%;
		}
		@media only screen and (max-width: ${TABLET_BP}px) {
			top: 15%;
		}

		& > svg {
			width: 30vw;

			@media only screen and (max-width: ${DESKTOP_L_BP}px) {
				transform: rotate(10deg);
				width: 28vw;
			}
			@media only screen and (max-width: ${TABLET_M_BP}px) {
				transform: rotate(20deg);
			}
			@media only screen and (max-width: ${TABLET_BP}px) {
				transform: rotate(35deg);
				width: 34vw;
			}
			@media only screen and (max-width: ${MOBILE_L_BP}px) {
				width: 42vw;
			}

			& > path {
				@media only screen and (max-width: ${TABLET_BP}px) {
					stroke-width: 8px;
				}
			}
		}
	}

	.line-right {
		top: 35%;
		@media only screen and (max-width: ${DESKTOP_L_BP}px) {
			top: 50%;
		}
		@media only screen and (max-width: ${TABLET_M_BP}px) {
			top: 60%;
		}
		@media only screen and (max-width: ${TABLET_BP}px) {
			top: 65%;
		}
		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			top: 75%;
			right: 10%;
		}

		& > svg {
			width: 32vw;
			@media only screen and (max-width: ${DESKTOP_L_BP}px) {
				transform: rotate(10deg);
				width: 30vw;
			}
			@media only screen and (max-width: ${TABLET_M_BP}px) {
				transform: rotate(25deg);
			}
			@media only screen and (max-width: ${TABLET_BP}px) {
				transform: rotate(35deg);
				width: 34vw;
			}
			@media only screen and (max-width: ${MOBILE_L_BP}px) {
				transform: rotate(45deg);
				width: 48vw;
			}

			& > path {
				@media only screen and (max-width: ${TABLET_BP}px) {
					stroke-width: 8px;
				}
			}
		}
	}
`;
